import axios from "axios";

const deleteImageFromS3 = async ({ imageUrl, token }) => {
  const serverURL = process.env.REACT_APP_URL;
  if (!imageUrl) return true;

  try {
    await axios.post(
      `${serverURL}/deleteUpload`,
      {
        keys: [imageUrl],
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return true;
  } catch (error) {
    console.error("S3 delete failed", error);
    return false;
  }
};

export default deleteImageFromS3;
